
import { Component, HostListener, Inject, OnInit, Renderer2, DOCUMENT } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TYPE_MENU, TYPE_SECTIONS, VISIBILITY_ITEM } from 'app/core/models/constans.model';
import { DbService } from 'app/core/services/db.service';
import { Restaurant } from 'app/menu/models/restaurants.model';
import * as moment from 'moment';
import { PreloadImgComponent } from '../../../core/directives/preload-img/preload-img.component';
import { COLLECTIONS_BD } from '../../../core/models/collections.model';
import { Item, Menu, SectionMenu } from '../../models/menu.model';
import { MenuStorageService } from '../../services/menu-storage.service';
import { MenuService } from '../../services/menu.service';

/**
 * Componente que muestra el menu del restaurante
 */
@Component({
    selector: 'app-preview-menu',
    templateUrl: './preview-menu.component.html',
    styleUrls: ['./preview-menu.component.scss'],
    standalone: false
})
export class PreviewMenuComponent extends PreloadImgComponent implements OnInit {
  /**
   * Informacion del menu seleccionado
   */
  menu: Menu = {} as Menu;
  /**
   * Fecha actual
   */
  date = moment(new Date()).format('YYYY-MM-DD');
  /**
   * Selector de idioma
   */
  language = 'ES';
  /**
   * Identificador del restaurante
   */
  id = '';
  /**
   * indica el tipo de menu del restaurante
   */
  menuType = '';
  /**
   * Indica que tab esta seleccionado
   */
  tabIndexSelected = 0;
  /**
   * Informacion del restaurante actual
   */
  restaurant: Restaurant = {} as Restaurant;
  /**
   * Indica si los tabs estaran anclados al incio de la pagina
   */
  isSticky = false;
  px = 500;
  /**
   * Tipos de secciones
   */
  readonly TYPE_SECTIONS = TYPE_SECTIONS;
  /**
   * Constructor
   *
   * @param db conexion con BD
   * @param route ruta actual
   * @param router enrutador
   * @param menuStorage servicio de menu
   */
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private db: DbService,
    private route: ActivatedRoute,
    private router: Router,
    private menuStorage: MenuStorageService,
    public menuService: MenuService,
  ) {
    super();
  }

  /**
   * Se encarga de indicar si se hizo scroll en el menu
   * y poner fixed los tabs o el filtrado de secciones
   */
  @HostListener('body:scroll', ['$event'])
  onWindowScroll() {
    const scroll = window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    if (scroll >= this.px) {
      const matTabHeader: any = document.getElementsByClassName('mat-tab-header');
      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let index = 0; index < matTabHeader.length; index++) {
        matTabHeader[index].style.backgroundColor = this.menu.color;
        matTabHeader[index].style.backgroundImage = `url( ${this.menu.background})`;
      }
      this.isSticky = true;
    } else {
      this.isSticky = false;
    }
  }


  /**
   * Inicializa la informacion y valida si hay publicidades
   */
  ngOnInit(): void {
    this.menuService.setSideMenu(false);
    if (!this.menu.background) {
      this.menu.background = '';
    }
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.id = this.route.snapshot.params.id;
    this.getRestaurant();
  }
  /**
   * Filtra el contenido por una seccion seleccionada
   *
   * @param section seccion a filtrar
   */
  filterSection(section: SectionMenu): void {
    setTimeout(() => {
      const sectionSelect = document.getElementById(section.name + 'section');
      if (sectionSelect) {
        sectionSelect.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }, 200);
  }

  /**
   * Obtiene la informacion del restaurante actual
   */
  getRestaurant(): void {
    this.menuStorage.getRestaurant().subscribe((r: Restaurant) => {
      if (!r || !this.restaurant.name) {
        this.setRestaurant();
      } else {
        this.restaurant = r;
        this.menuType = r.menuType;
        if (r.language) {
          this.menuService.setLang(r.language);
          this.language = r.language;
        } else {
          this.menuService.setLang('ES');
        }
      }
      setTimeout(() => {
        this.loadInfo();
      }, 100);
    });
  }

  /**
   * Carga la informacion del menu dependiendo
   * el departamento seleccionado
   * Bar, cocina, ambos
   */
  loadInfo(): void {
    this.db.get(`${COLLECTIONS_BD.restaurants}/${this.route.snapshot.params.id}/menu`,
      ['departament', 'in', [this.route.snapshot.params.type, 'imagesMenu']])
      .subscribe((menu: Menu[]) => {
        if (this.menu.shape) {
          this.px = 180;
        };
        let menuRestaurant: Menu = {} as Menu;
        if (this.menuType === 'imagesMenu') {
          let type = 'imagesMenu';
          if (this.route.snapshot.params.type === 'imagesMenuEn' || this.route.snapshot.params.type === 'imagesMenuEs') {
            type = this.route.snapshot.params.type;
          }
          const exist = menu.find((m: Menu) => m.departament === type);
          if (exist) {
            menuRestaurant = exist;
          }
        } else {
          const exist = menu.find((m: Menu) => (m.departament === this.route.snapshot.params.type));
          if (exist) {
            menuRestaurant = exist;
          }
        }
        const menuFiltered = menuRestaurant.sections.map((r: SectionMenu) => {
          let items: Item[] = [];
          if (r.type === TYPE_SECTIONS.drinks || r.type === TYPE_SECTIONS.drinks_midle || r.type === TYPE_SECTIONS.wines) {
            items = r.items.filter((s: Item) => ((s.typeMenu === VISIBILITY_ITEM.restaurantAndDelivery ||
              s.typeMenu === VISIBILITY_ITEM.restaurant || !s.typeMenu) &&
              (s.availableBotle === 'S' || s.availableDrink === 'S' || s.comment === 'separator')));
          } else {
            items = r.items.filter((s: Item) => ((s.typeMenu === VISIBILITY_ITEM.restaurantAndDelivery ||
              s.typeMenu === VISIBILITY_ITEM.restaurant || !s.typeMenu) && s.available === 'S'));
          }
          items = items.map((i: any) => ({ ...i, section: r.name }));
          return {
            ...r,
            items,
            photo: r.photo ? r.photo : undefined,
          };
        }
        );
        let sectionsMenu = menuFiltered.filter((s: SectionMenu) =>
        ((s.items.length) > 0 ||
          (s.items.length === 0 && s.type === TYPE_SECTIONS.separator && menuRestaurant.shape === 'scroll')));
        sectionsMenu = sectionsMenu.filter((section: SectionMenu) => !section.isInactive);
        menuRestaurant.sections = sectionsMenu;
        setTimeout(() => {
          this.menu = menuRestaurant;
          this.menuStorage.setMenu(menuRestaurant);
          this.setColors();
          if (this.menu.shape === 'tabs' || !this.menu.shape) {
            this.menu.sections.map((section: SectionMenu) => ({
              ...section,
              name: section.name.toUpperCase(),
              nameEn: section.nameEn.toUpperCase(),
            }));
            this.renderer.removeClass(this.document.body, 'embedded-body');
          }
          this.setColors();
          this.setColorsFilterSections();
        }, 200);
      });
  }


  tabChange(): void {
    if (window.innerWidth < 760) {
      document.body.scrollTop = 0;
    }
  }

  /**
   * Navega al la pagina anterior
   */
  back(): void {
    if (this.restaurant.home) {
      this.menuService.setHome(false);
    }
    this.router.navigateByUrl(`/menu/${this.route.snapshot.params.id}`);
  }

  /**
   * Intercambia los valores del lenguaje seleccionado
   */
  selectLanguage(): void {
    if (this.language === 'ES') {
      this.language = 'EN';
      this.menuService.setLang('EN');
    } else {
      this.menuService.setLang('ES');
      this.language = 'ES';
    }
  }

  /**
   * Indica si el menu es de imagenes o no
   *
   * @returns boolean
   */
  isMenuImages(): boolean {
    if (this.menuType === TYPE_MENU.imagesMenu ||
      this.menuType === TYPE_MENU.imagesMenuEn ||
      this.menuType === TYPE_MENU.imagesMenuEs) {
      return true;
    }
    return false;
  }

  /**
   * Establece los colores del
   * matTabGroup segun lo establecido
   * en el menu seleccionado
   */
  private setColors(): void {
    setTimeout(() => {
      const arrows: any = document.getElementsByClassName('mat-tab-header-pagination-chevron');
      const tabLabels: any = document.getElementsByClassName('mat-tab-label-content');
      const underLines: any = document.getElementsByClassName('mat-ink-bar ');
      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let index = 0; index < underLines.length; index++) {
        underLines[index].style.backgroundColor = this.menu.colorText;
      }
      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let index = 0; index < tabLabels.length; index++) {
        tabLabels[index].style.color = this.menu.colorText;
        tabLabels[index].style.fontFamily = this.menu.fontSections ? this.menu.fontSections : this.menu.fontHeader;
      }
      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let index = 0; index < arrows.length; index++) {
        arrows[index].style.borderColor = this.menu.colorText;
      }
      if (this.menu.shape === 'scroll') {
        this.setColorsFilterSections();
      }
    }, 400);
  }

  /**
   * Establece los colores del
   * filtro de secciones segun lo establecido
   * en el menu seleccionado
   */
  private setColorsFilterSections(): void {
    setTimeout(() => {
      const outline: any = document.getElementsByClassName('mat-form-field-outline');
      const label: any = document.getElementsByClassName('mat-form-field-label');
      const category: any = document.getElementsByClassName('mat-select-value');
      const arrow: any = document.getElementsByClassName('mat-select-arrow');

      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let index = 0; index < category.length; index++) {
        category[index].style.color = this.menu.colorText + '!important';
      }
      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let index = 0; index < label.length; index++) {
        label[index].style.color = this.menu.colorText;
      }
      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let index = 0; index < outline.length; index++) {
        outline[index].style.color = this.menu.colorText;
      }
      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let index = 0; index < arrow.length; index++) {
        arrow[index].style.color = this.menu.colorText;
      }
    }, 400);
  }


  /**
   * Obtiene la informacion del restaurante actual
   */
  private setRestaurant(): void {
    this.db.findOne(COLLECTIONS_BD.restaurants, this.route.snapshot.params.id).subscribe((r: Restaurant) => {
      this.menuType = r.menuType;
      if (r.language) {
        this.language = r.language;
        this.menuService.setLang(r.language);
      }
      this.restaurant = r;
      this.restaurant.id = this.route.snapshot.params.id;
      this.menuStorage.setRestaurant(this.restaurant);
    });
  }
}


